import { brand } from "@/shared/lib/safecheckBrand";

export const auditorDashboardData = {
  header: {
    invoicesToAudit: 12,
    pendingRequests: 16,
    roleBadge: "Guystave MONYAWANGERE",
    displayDate: "27 juin 2026",
  },
  indicators: [
    {
      id: "invoices",
      value: 23,
      icon: "file",
      iconClassName: "bg-primary-soft text-primary",
      footerKey: "cumulative",
      footerIcon: "minus",
      footerClassName: "text-muted",
    },
    {
      id: "submitted",
      value: 12,
      icon: "upload",
      iconClassName: "bg-accent-soft text-accent",
      footerKey: "pending",
      footerIcon: "hourglass",
      footerClassName: "text-muted-foreground",
    },
    {
      id: "review",
      value: 9,
      icon: "clock",
      iconClassName: "bg-primary-soft text-primary",
      footerKey: "inProgress",
      footerIcon: "activity",
      footerClassName: "text-muted",
    },
    {
      id: "approved",
      value: 2,
      icon: "check",
      iconClassName: "bg-accent-soft text-accent",
      footerKey: "validated",
      footerIcon: "trending",
      footerClassName: "text-accent",
    },
    {
      id: "paid",
      value: 0,
      icon: "wallet",
      iconClassName: "bg-accent-soft text-accent",
      footerKey: "settled",
      footerIcon: "dollar",
      footerClassName: "text-accent",
    },
    {
      id: "rejected",
      value: 0,
      icon: "x",
      iconClassName: "bg-danger-soft text-danger",
      footerKey: "toFix",
      footerIcon: "x",
      footerClassName: "text-danger",
    },
    {
      id: "validation",
      value: 16,
      icon: "clipboard",
      iconClassName: "bg-accent-soft text-accent-foreground",
      footerKey: "pending",
      footerIcon: "hourglass",
      footerClassName: "text-muted-foreground",
    },
  ],
  quickActions: [
    {
      id: "toAudit",
      href: "/dashboard/invoices/pending",
      icon: "search",
      iconClassName: "text-primary",
    },
    {
      id: "approved",
      href: "/dashboard/invoices/approved",
      icon: "check",
      iconClassName: "text-accent",
    },
    {
      id: "rejected",
      href: "/dashboard/invoices/rejected",
      icon: "x",
      iconClassName: "text-danger",
    },
    {
      id: "admissions",
      href: "/dashboard/admissions",
      icon: "home",
      iconClassName: "text-primary",
    },
  ],
  invoiceDistribution: [
    { key: "submitted", value: 12, color: brand.lime },
    { key: "review", value: 9, color: brand.navyLight },
    { key: "approved", value: 2, color: brand.limeDark },
    { key: "paid", value: 0, color: brand.lime },
    { key: "modify", value: 0, color: brand.navyDark },
  ],
  productivity: {
    auditedToday: "—",
    avgAuditTime: "—",
    pendingOver48h: "—",
  },
  hospitalFilterOptions: [
    { value: "", labelKey: "allHospitals" as const },
    { value: "afia", label: "POLYCLINIQUE AFIA DON BOSCO" },
    { value: "mwangeji", label: "HGR MWANGEJI" },
  ],
  companyFilterOptions: [
    { value: "", labelKey: "allCompanies" as const },
    {
      value: "ceec",
      label: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    },
  ],
  submittedInvoices: [
    {
      id: "aud-9",
      displayId: 9,
      hospitalKey: "afia",
      hospital: "POLYCLINIQUE AFIA DON BOSCO",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 40,
      submittedDate: "06/06/2026",
      delayDays: 20,
      priority: "urgent",
    },
    {
      id: "aud-8",
      displayId: 8,
      hospitalKey: "mwangeji",
      hospital: "HGR MWANGEJI",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 11200,
      submittedDate: "06/06/2026",
      delayDays: 20,
      priority: "urgent",
    },
    {
      id: "aud-7",
      displayId: 7,
      hospitalKey: "afia",
      hospital: "POLYCLINIQUE AFIA DON BOSCO",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 9200,
      submittedDate: "06/06/2026",
      delayDays: 21,
      priority: "urgent",
    },
    {
      id: "aud-6",
      displayId: 6,
      hospitalKey: "mwangeji",
      hospital: "HGR MWANGEJI",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 1480,
      submittedDate: "06/06/2026",
      delayDays: 21,
      priority: "urgent",
    },
    {
      id: "aud-5",
      displayId: 5,
      hospitalKey: "afia",
      hospital: "POLYCLINIQUE AFIA DON BOSCO",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 6300,
      submittedDate: "06/06/2026",
      delayDays: 21,
      priority: "urgent",
    },
    {
      id: "aud-4",
      displayId: 4,
      hospitalKey: "mwangeji",
      hospital: "HGR MWANGEJI",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 2750,
      submittedDate: "06/06/2026",
      delayDays: 21,
      priority: "urgent",
    },
    {
      id: "aud-3",
      displayId: 3,
      hospitalKey: "afia",
      hospital: "POLYCLINIQUE AFIA DON BOSCO",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 1890,
      submittedDate: "06/06/2026",
      delayDays: 21,
      priority: "urgent",
    },
    {
      id: "aud-2a",
      displayId: 2,
      hospitalKey: "mwangeji",
      hospital: "HGR MWANGEJI",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 540,
      submittedDate: "24/06/2026",
      delayDays: 2,
      priority: "normal",
    },
    {
      id: "aud-2b",
      displayId: 2,
      hospitalKey: "afia",
      hospital: "POLYCLINIQUE AFIA DON BOSCO",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 320,
      submittedDate: "24/06/2026",
      delayDays: 2,
      priority: "normal",
    },
    {
      id: "aud-1a",
      displayId: 1,
      hospitalKey: "mwangeji",
      hospital: "HGR MWANGEJI",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 780,
      submittedDate: "24/06/2026",
      delayDays: 2,
      priority: "normal",
    },
    {
      id: "aud-1b",
      displayId: 1,
      hospitalKey: "afia",
      hospital: "POLYCLINIQUE AFIA DON BOSCO",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 150,
      submittedDate: "24/06/2026",
      delayDays: 2,
      priority: "normal",
    },
    {
      id: "aud-1c",
      displayId: 1,
      hospitalKey: "mwangeji",
      hospital: "HGR MWANGEJI",
      companyKey: "ceec",
      company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
      amount: 95,
      submittedDate: "25/06/2026",
      delayDays: 2,
      priority: "normal",
    },
  ],
} as const;

export type AuditorSubmittedInvoice = (typeof auditorDashboardData.submittedInvoices)[number];
